import { render, staticRenderFns } from "./pickup-points.vue?vue&type=template&id=4b744c83"
import script from "./pickup-points.js?vue&type=script&lang=js&external"
export * from "./pickup-points.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports